import * as React from 'react';
import { Input, Label } from 'reactstrap';

import { ToString } from '../../lib/utils';

import SearchSvg from '../Svg/search';
import Place from './Places';

import './SearchInput.scss';
import { isEqual } from 'lodash';

class SearchInput<T = Utils.ISelect> extends React.Component<SearchInput.IProps<T>, SearchInput.IState> {
  static defaultProps = { width: 'w-25', margin: 'mt-5', withValidation: true, required: false };

  state: SearchInput.IState = { searchTerm: '', isFocused: false, inputFocused: false };

  componentDidMount() {
    if (this.props.defaultOption) {
      this.setState({ searchTerm: this.props.getLabel(this.props.defaultOption) });
    }
  }

  componentDidUpdate(prevProps: Readonly<SearchInput.IProps<T>>) {
    if (!isEqual(prevProps.defaultOption, this.props.defaultOption)) {
      const searchTerm = this.props.getLabel(this.props.defaultOption);
      this.setState({ searchTerm, isFocused: false, inputFocused: false });
    }
  }

  render() {
    const showMoreResults =
      (this.state.isFocused || this.state.inputFocused) &&
      (this.props.defaultOption === undefined || this.props.getLabel(this.props.defaultOption) !== this.state.searchTerm);

    return (
      <div
        className={`search-box ${this.props.width} ${this.props.margin} position-relative ${ToString(this.props.className)}`}
        onMouseEnter={this._onMouseEnter}
        onMouseLeave={this._onMouseLeave}
      >
        {this.props.label && <Label>{this.props.label}</Label>}
        <div className="position-relative">
          <Input
            required={this.props.required}
            className={`search-input ${this.props.error ? 'invalid' : ''}`}
            onChange={this._searchUpdated}
            value={this.state.searchTerm}
            placeholder={this.props.placeholder}
            onFocus={this._onFocus}
            onBlur={this._onBlur}
          />
          <SearchSvg className="position-absolute m-auto" />
        </div>
        <div className="search-results position-absolute w-100">
          {showMoreResults &&
          this.props.places &&
          this.props.places.map((place, index) => (
            <Place
              key={index}
              getLabel={this.props.getLabel}
              place={place}
              onClick={this._onClick}
            />
          ))}
        </div>

        {this.props.error ? <span className="label-error">{this.props.error}</span> : null}
      </div>
    );
  }

  _onFocus = () => this.setState({ inputFocused: true });

  _onBlur = () => this.setState({ inputFocused: false });

  _onMouseEnter = () => this.setState({ isFocused: true });

  _onMouseLeave = () => this.setState({ isFocused: false });

  _searchUpdated = async (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    const element = event.currentTarget || event.target || {};

    const searchTerm = element.value;
    await this.setState({ searchTerm });

    if (this.props.withValidation && searchTerm.length < 2) return undefined;

    return this.props.onUpdate && this.props.onUpdate(searchTerm);
  };

  _onClick = async (place: T) => {
    await this.setState({ searchTerm: this.props.getLabel(place) });

    return this.props.onChange && this.props.onChange(place);
  };
}

export default SearchInput;
